// extracted by mini-css-extract-plugin
var _1 = "K9OievjQ";
var _2 = "szBtBhnA";
export { _1 as "root", _2 as "rootMobile" }
